import styled from '@emotion/styled';
import { colors } from 'crono-fe-common/theme';

export const CreditsBadgeWrapper = styled.div`
  .credits,
  .credits-insufficient {
    display: flex;
    width: fit-content;
    gap: 4px;
    border-radius: 20px;
    align-items: center;
    height: 26px;
  }
  .credits {
    padding: 3px 3px 3px 8px;
    &:not(.disabled):hover {
      cursor: pointer;
    }

    &--insufficient {
      background: ${colors.inactiveLight} !important;
      color: ${colors.inactiveHover} !important;
      &:hover {
        background: ${colors.inactiveLightHover} !important;
      }
    }
    &--enrichment {
      background: ${colors.transparentBlue};
      color: ${colors.lightBlueHover};
      &:hover {
        background: ${colors.transparentBlueHover};
      }
    }
    &--rewrite {
      background: ${colors.rewriteCreditsLight};
      color: ${colors.rewriteCredits};
      &:hover {
        background: ${colors.purpleLightHover};
      }
    }
    &--phone {
      background: ${colors.findPhoneCreditsLight};
      color: ${colors.findPhoneCredits};
      &:hover {
        background: ${colors.nurtureLightHover};
      }
    }
  }

  .buy-more-button,
  .remaining-credits {
    display: flex;
    align-items: center;
    gap: 2px;
    padding: 2px 4px 2px 6px;
    border-radius: 20px;
    height: 18px;
  }
  .remaining-credits {
    background: white;
  }
  .remaining-credits:has(.buy-more-button) {
    padding-right: 0;
  }
  .buy-more-button {
    background: ${colors.inactive};
    &:not(.disabled):hover {
      cursor: pointer;
      background: ${colors.inactiveHover};
    }
  }
`;
